import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FlatScreenIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FlatScreenIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M6.005 15.0724C5.93118 14.6753 5.45337 14.4776 5.1205 14.706C4.71834 14.9706 4.81098 15.5994 5.27301 15.736C5.68289 15.8654 6.09338 15.4928 6.005 15.0724Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.44041 8.46654C5.64228 8.46654 5.84134 8.48421 6.03218 8.51897C7.54498 8.79481 8.92213 9.5182 10.0148 10.6109C11.1075 11.7036 11.8308 13.0807 12.1067 14.5936C12.1415 14.7843 12.1591 14.9833 12.1591 15.1853C12.1591 15.5034 12.417 15.7614 12.7352 15.7614C13.0534 15.7614 13.3113 15.5034 13.3113 15.1853C13.3113 14.9142 13.2874 14.6456 13.2402 14.3868C12.9221 12.6426 12.0886 11.0552 10.8295 9.79617C9.57046 8.53712 7.98304 7.70355 6.2388 7.38546C5.97998 7.33826 5.71136 7.31433 5.44036 7.31433C5.1222 7.31433 4.86426 7.57227 4.86426 7.89043C4.86426 8.20859 5.12221 8.46654 5.44041 8.46654Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.51591 9.60352C5.20078 9.56193 4.91097 9.78372 4.8693 10.0991C4.82759 10.4146 5.04947 10.7041 5.3649 10.7458C7.71262 11.0562 9.56912 12.9127 9.8796 15.2605C9.91789 15.5503 10.1654 15.7611 10.45 15.7611C10.4752 15.7611 10.5006 15.7595 10.5263 15.7561C10.8417 15.7144 11.0635 15.4249 11.0218 15.1095C10.6432 12.2463 8.37913 9.9821 5.51591 9.60352Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.31546 13.075C6.42626 13.3219 7.30358 14.1993 7.55046 15.31C7.61014 15.5785 7.84819 15.7612 8.11231 15.7612C8.15367 15.7612 8.19577 15.7567 8.23786 15.7474C8.54845 15.6783 8.7443 15.3705 8.67523 15.06C8.33169 13.5145 7.111 12.2938 5.56548 11.9502C5.25477 11.8812 4.94713 12.077 4.87812 12.3876C4.80903 12.6982 5.00486 13.006 5.31546 13.075Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.7961 4.68835H3.28411C2.96595 4.68835 2.70801 4.94629 2.70801 5.26445V17.4074C2.70801 17.7255 2.96595 17.9835 3.28411 17.9835H5.71037L5.12386 18.9843C4.96297 19.2588 5.05511 19.6117 5.3296 19.7726C5.42116 19.8262 5.52136 19.8517 5.62034 19.8517C5.8181 19.8517 6.01067 19.7498 6.1179 19.5668L7.0458 17.9835H18.0344L18.9623 19.5668C19.0695 19.7498 19.2621 19.8517 19.4598 19.8517C19.5588 19.8517 19.6591 19.8262 19.7506 19.7726C20.025 19.6117 20.1172 19.2587 19.9563 18.9843L19.3698 17.9835H21.7961C22.1142 17.9835 22.3722 17.7255 22.3722 17.4074V5.26441C22.3722 4.94625 22.1143 4.68835 21.7961 4.68835ZM21.22 16.8312H3.86021V5.84051H21.22V16.8312Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FlatScreenIcon;
